var FormGroupVerticalAlign = {
  Top: "top",
  Middle: "middle",
  Bottom: "bottom",
  Stretch: "stretch"
};

export { FormGroupVerticalAlign };
